// import { BillingData } from 'business-layer/types';
import {
  IsEmail,
  IsNotEmpty,
  IsOptional,
  IsNumber,
  IsString,
  // IsArray,
  ValidateNested,
} from 'class-validator';
import { Transform, Type } from 'class-transformer';

export class NextActionDetailsDto {
  @IsNumber()
  @IsOptional()
  expires: number;

  @IsString()
  @IsOptional()
  number: string;

  @IsString()
  @IsNotEmpty()
  url: string;
}
export class NextActionDto {
  @IsString()
  @IsNotEmpty()
  type: string;

  @ValidateNested()
  @Type(() => NextActionDetailsDto)
  details:NextActionDetailsDto;
}

export class PaymentDetailsDto {
    @IsNotEmpty()
    @IsString()
    id: string;

    @IsNotEmpty()
    @IsNumber()
    @Transform(({ value }) => +value, { toClassOnly: true })
    reservationId: number;

    @IsNotEmpty()
    reservationIdentifier: number | string;

    /*
      TODO: replace with enum 'success', 'expired', 'declined', 'new', else???
      this param is for identifying currect payment status
      location: all pages
    */
    @IsNotEmpty()
    @IsString()
    status: string;

    @IsOptional()
    @IsString()
    country: string;

    @IsString()
    captureMethod: string;

    /*
      description: Amount to pay
      location: all pages
    */
    @IsNumber()
    @Transform(({ value }) => +value, { toClassOnly: true })
    amount: number;

    /*
      description: Currency symbol or code
      location: all pages
    */
    @IsString()
    currency: string;

    /*
      description: Human readable card type to display on FE
      location: Success and Decline page
    */
    @IsOptional()
    @IsString()
    cardType: string;

    /*
      description: last 4 digits of card number or xxxx-xxxx-xxxx-3244
      location: Success and Decline page
    */
    @IsOptional()
    @IsString()
    cardNumber: string;

    /*
      description: Transaction date time
      location: Success and Decline page
    */
    @IsOptional()
    @IsString()
    paidDate: string;

    /*
      description: Remaining balance (not sure what it is)
      location: Success and Decline page
    */
    @IsOptional()
    @IsNumber()
    @Transform(({ value }) => +value, { toClassOnly: true })
    remains: number;

    /*
      description: reservation's user first name
      location: Main and Decline page
    */
    @IsOptional()
    @IsString()
    firstName: string;

    /*
      description: reservation's user last name
      location: Main and Decline page
    */
    @IsOptional()
    @IsString()
    lastName: string;

    /*
      description: Name as on card
      location: Decline page
    */
    @IsOptional()
    @IsString()
    cardholderName: string;

    /*
      description: reservation's user email
      location: Decline page
    */
    @IsOptional()
    @IsString()
    email: string;

    @IsOptional()
    @Type(() => NextActionDto)
    nextAction: NextActionDto;
}

class PropertyDetailsDto {
  /*
    description: Property internal ID
    location: all pages
  */
  @IsNotEmpty()
  @IsNumber()
  @Transform(({ value }) => +value, { toClassOnly: true })
  propertyId: number;

  /*
    description: Property logo displayed on the right pane. URL to the image or base64 image
    location: all pages
  */
  @IsString()
  propertyLogo: string;

  /*
    description: Property name
    location: all pages except Declined page
  */
  @IsNotEmpty()
  @IsString()
  propertyName: string;

  /*
    description: Property address line 1
    location: all pages except Declined page
  */
  @IsOptional()
  @IsString()
  address1: string;

  /*
    description: Property address line 2
    location: all pages except Declined page
  */
  @IsOptional()
  address2: string;

  /*
    description: Property city
    location: all pages except Declined page
  */
  @IsString()
  city: string;

  /*
    description: Property state
    location: all pages except Declined page
  */
  @IsString()
  state: string;

  /*
    description: Property zip
    location: all pages except Declined page
  */
  @IsString()
  zip: string;

  /*
    description: Property country
    location: all pages except Declined page
  */
  @IsString()
  country: string;

  /*
    description: Property phone
    location: all pages except Declined page
  */
  @IsString()
  phone: string;

  /*
    description: Property email
    location: all pages except Declined page
  */
  @IsEmail()
  email: string;

}

export class PaymentDataDto {
  /*
    Description: see PaymentDetailsDto above
    location: all pages
  */
  @ValidateNested()
  @Type(() => PaymentDetailsDto)
  payment: PaymentDetailsDto;

  /*
    Description: see PropertyDetailsDto above
    location: all pages
  */
  @ValidateNested()
  @Type(() => PropertyDetailsDto)
  property: PropertyDetailsDto;

  paymentElementApiKey: string;
};
